export const hm5GlobalReleaseConstants = {
  HM5_GLOBAL_RELEASE_LOADING: "HM5_GLOBAL_RELEASE_LOADING",
  HM5_GLOBAL_RELEASE_SUCCESS: "HM5_GLOBAL_RELEASE_SUCCESS",
  HM5_GLOBAL_RELEASE_FAILURE: "HM5_GLOBAL_RELEASE_FAILURE",
};

export const addHM5GlobalReleaseConstants = {
  ADD_HM5_GLOBAL_RELEASE_LOADING: "ADD_HM5_GLOBAL_RELEASE_LOADING",
  ADD_HM5_GLOBAL_RELEASE_SUCCESS: "ADD_HM5_GLOBAL_RELEASE_SUCCESS",
  ADD_HM5_GLOBAL_RELEASE_FAILURE: "ADD_HM5_GLOBAL_RELEASE_FAILURE",
};

export const editHM5GlobalReleaseConstants = {
  EDIT_HM5_GLOBAL_RELEASE_LOADING: "EDIT_HM5_GLOBAL_RELEASE_LOADING",
  EDIT_HM5_GLOBAL_RELEASE_SUCCESS: "EDIT_HM5_GLOBAL_RELEASE_SUCCESS",
  EDIT_HM5_GLOBAL_RELEASE_FAILURE: "EDIT_HM5_GLOBAL_RELEASE_FAILURE",
};
